module.exports = __webpack_public_path__ + "static/sport/logo.53c47bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/road/logo.png
// module id = ph1m
// module chunks = 0